//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCsvExcelAccountsService } from "@/features/accounts/csv-excel/services/get-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useGetCsvExcelAccount = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getCsvExcelAccountsService = new GetCsvExcelAccountsService();

  // CsvExcel口座一覧取得
  const getCsvExcelAccounts = async (
    accountGroupId: string,
    csvExcelAccountId?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getCsvExcelAccountsService.getCsvExcelAccounts({
        account_group_id: accountGroupId,
        ...(csvExcelAccountId && { csvexcel_account_id: csvExcelAccountId }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getCsvExcelAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getCsvExcelAccounts: errorHandledAsync(getCsvExcelAccounts, setError),
  };
};
